"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.messageReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var MessageAction_1 = require("@/pages/common/actions/MessageAction");
var MessageState_init_1 = require("@/pages/common/states/MessageState.init");
exports.messageReducer = function (state, action) {
    if (state === void 0) { state = MessageState_init_1.defaultMessageState; }
    switch (action.type) {
        case typesafe_actions_1.getType(MessageAction_1.default.onSetMessage): {
            var _a = action.payload, title = _a.title, message = _a.message, actionUrl = _a.actionUrl, actionText = _a.actionText, warningLevel = _a.warningLevel;
            return __assign(__assign({}, state), { message: message,
                warningLevel: warningLevel,
                title: title,
                actionText: actionText,
                actionUrl: actionUrl });
        }
        case typesafe_actions_1.getType(MessageAction_1.default.onSetActive): {
            return __assign(__assign({}, state), { active: action.payload });
        }
        case typesafe_actions_1.getType(MessageAction_1.default.messageClose): {
            return __assign(__assign({}, state), { active: false, message: '' });
        }
    }
    return state;
};
